import React, { Component } from "react";
import { connect } from "react-redux";

import {
  Container,
  KeyboardView,
  Wrapper,
  Row,
  Card,
  Spin,
  Title,
  Copy,
  Bold,
  CardBody
} from "app/NativeComponents/common";
import { Header, PillButton } from "app/NativeComponents/snippets";
import SavedReplyItem from "./SavedReplyItem";
import {
  appRedirect,
  setActiveConversation,
  setModal,
  toggleModal,
  getSavedResponses,
  updateSavedResponse,
  setEditModal
} from "app/NativeActions";

import OnboardingText from "app/DealMachineCore/snippets/OnboardingText";

class ManageSavedReplies extends Component {
  componentDidMount() {
    this.props.setActiveConversation({ conversation: "manage_saved_replies" });
    this.props.getSavedResponses({ token: this.props.token });
    if (this.props.user.team_clearance_level < 2) {
      this.handleBack();
    }
  }

  handleBack() {
    this.props.setActiveConversation({ conversation: null });
    this.props.appRedirect({
      redirect: "goBack",
      payload: { type: "message_engine" }
    });
  }

  render() {
    return (
      <Container>
        <Header
          title="Manage Saved Replies"
          leftButtonIcon={"arrow-back"}
          leftButtonAction={() => this.handleBack()}
        />
        <KeyboardView>
          {this.props.saved_responses_loading ? (
            <Wrapper style={{ alignItems: "center", justifyContent: "center" }}>
              <Row>
                <Spin size="small" />
                <Copy style={{ marginLeft: 10 }}>Loading...</Copy>
              </Row>
            </Wrapper>
          ) : (
            <Wrapper>
              <Card>
                <CardBody>
                  <Wrapper style={{ marginBottom: 10 }}>
                    <OnboardingText
                      slug="manageSavedReplies"
                      style={{
                        padding: 0
                      }}
                      innerStyle={{
                        padding: 20,
                        paddingTop: 0,
                        paddingBottom: 0
                      }}
                    />
                  </Wrapper>
                  <Row>
                    <PillButton
                      onPress={() => {
                        this.props.setEditModal({
                          title: "Create Saved Reply",
                          description:
                            "Create a reply to be used in other conversations.",
                          slug: "create-saved-reply",
                          type: "create_saved_reply",
                          fields: {
                            response_text: "",
                            starting_response: false
                          },
                          save_button_text: "Create Saved Reply",
                          modalAction: ({ fields }) => {
                            this.props.updateSavedResponse({
                              token: this.props.token,
                              type: "create_saved_response",
                              response_text: fields.response_text,
                              starting_response: fields.starting_response,
                              onSuccess: () => {
                                this.props.appRedirect({
                                  redirect: "goBack",
                                  payload: { remove: "create-saved-reply" }
                                });
                              }
                            });
                          },
                          always_save: true,
                          cancelAction: () => {},
                          fieldsUpdated: fields => {}
                        });
                        this.props.appRedirect({
                          redirect: "goForward",
                          payload: { add: "create-saved-reply" }
                        });
                      }}
                      primary={true}
                    >
                      Create Saved Reply
                    </PillButton>
                  </Row>
                </CardBody>
              </Card>
              {this.props.saved_responses.map((saved_reply, i) => {
                return (
                  <SavedReplyItem
                    {...this.props}
                    key={"saved_reply_item" + i}
                    saved_reply={saved_reply}
                  />
                );
              })}
            </Wrapper>
          )}
        </KeyboardView>
      </Container>
    );
  }
}

const mapStateToProps = ({ auth, settings, native, message }) => {
  const { token, user, onboarding } = auth;
  const { colors } = settings;
  const { device, platform, isMobile } = native;

  const { saved_responses, saved_responses_loading } = message;
  return {
    token,
    user,
    colors,
    onboarding,
    device,
    platform,
    isMobile,

    saved_responses,
    saved_responses_loading
  };
};

export default connect(mapStateToProps, {
  appRedirect,
  setActiveConversation,
  setModal,
  toggleModal,
  getSavedResponses,
  updateSavedResponse,
  setEditModal
})(ManageSavedReplies);
